import { AsyncPipe, NgForOf, NgIf } from "@angular/common";
import { Component } from "@angular/core";

import { SavedSearchesService } from "../saved-searches.service";

import { SavedSearchCardComponent } from "./saved-search-card/saved-search-card.component";

@Component({
    selector: SavedSearchesPageComponent.SELECTOR,
    templateUrl: "saved-searches-page.component.html",
    imports: [
        SavedSearchCardComponent,
        NgForOf,
        NgIf,
        AsyncPipe
    ],
    standalone: true
})
export class SavedSearchesPageComponent {
    public static SELECTOR = "pcg-ng-saved-searches-page";
    public constructor(
        public savedSearchesService: SavedSearchesService
    ) {
    }

    public back(e: Event): void {
        e.preventDefault();
        window.history.back();
    }
}
